'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-list', {
      url: '/document/:type',
      template: '<document-list></document-list>',
        authenticate: true
    })
    .state('public-document-list', {
      url: '/public/document/:type',
      template: '<document-list public="true"></document-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/document/list/document-list.routes.js